import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import InformationBarUtils from '../commons/header/information-bar-header-utils';
import { Inject } from '@odinjs/odin';
import { ChemoEncontersListAliases, FragmentNames } from '../../codegen';
import { ContextualBarAPI, PanelAPI } from '@philips-internal/oswald-ui-components';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ApplicationRoute } from '../../constants/routes';

interface ClickCard {
  nrSequence: string,
  prescriptionId: string,
}

@Controller({ component: ChemoEncontersListAliases.LAYOUT_CHEMO_ENCONTERS_LIST, fragment: FragmentNames.CHEMO_ENCONTERS_LIST })
class ChemoEncontersListController extends BaseController {
  @Inject(ChemoEncontersListAliases.PANEL_CHEMO_PROTOCOL_CARD)
  declare panelChemoProtocolCard: PanelAPI;

  @Inject(ChemoEncontersListAliases.CONTEXTUAL_CARDS)
  declare contextualCards: ContextualBarAPI;

  redirectCardSelect(value: ClickCard): void {
    const sequenceId = value.nrSequence;

    const { patientId, encounterId } = this.historyService.getCurrentRouteParams();

    applicationContext.redirect(
      ApplicationRoute.START_END_ADMCHEMO,
      { encounterId, patientId, sequenceId }
    );
  }

  returnToFilterScreenAndBarcode(): void {
    applicationContext.clearNavigationStack();
    applicationContext.pushNavigationItem(() => {
      this.historyService.push(
        `${ApplicationRoute.CHEMOTHERAPY}${ApplicationRoute.SEARCH_PATIENT}`
      );
    });
  }

  @OnMount(ChemoEncontersListAliases.LAYOUT_CHEMO_ENCONTERS_LIST)
  async onMount(): Promise<void> {
    InformationBarUtils.collapsedBar = true;
    const { patientId, encounterId } = this.historyService.getCurrentRouteParams();

    this.context.set({
      encounterId,
      patientId,
    });
    const title1 = MessageService.translate(this.contextualCards.getTitle());
    const title2 =  ' (' + MessageService.translate('tws.time.today') + ')';
    this.contextualCards.setTitle(title1 + title2);

    this.returnToFilterScreenAndBarcode();
  }

  @OnClick(ChemoEncontersListAliases.DECK_CHEMO_PROTOCOL_CARD)
  onClickMedicalPrescriptionCard(evt: ClickEvent): void {
    const value = evt.value as ClickCard;
    this.redirectCardSelect(value);
  }
}

export default ChemoEncontersListController;
